<h1 mat-dialog-title>Origin Criteria Info</h1>

<mat-dialog-content>
    <div class="bds-error-message">{{ errorMessage }}</div>
    <div>
        <bds-origin-criteria-details
            [originCriteria]="initialOrigCriteria"
            [originCodeStore]="data.originCodes"
            [railroadStore]="data.railroads"
            [states]="data.states"
            [sightCodes]="data.sightCodes"
            [isNew]="data.isNew"
            [isClone]="data.isClone"
            (originCriteriaChange)="onOriginCriteriaChanged($event)"
        >
        </bds-origin-criteria-details>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button
        mat-button
        [disabled]="!isValid"
        *ngIf="data.isNew || data.isClone"
        class="text-uppercase"
        color="accent"
        (click)="onSaveClick(true)"
    >
        Save and Create New Origin Criteria
    </button>

    <div class="break"></div>

    <button
        mat-button
        [disabled]="!isValid"
        class="text-uppercase"
        color="accent"
        (click)="onSaveClick(false)"
    >
        Save Origin Criteria
    </button>

    <div class="break"></div>

    <button mat-button class="text-uppercase" color="accent" (click)="onCancelClick()">
        Cancel
    </button>
</mat-dialog-actions>
